import { EntityHeader, Header, IndicatorsTabs } from 'components';
import { useDataTestId } from 'hooks';

import { useStyles } from './styles';

interface MainLayoutProps {
  children?: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps): JSX.Element {
  const { mainContainerStyle, contentContainer } = useStyles();
  const { getTestId } = useDataTestId();

  return (
    <>
      <Header {...getTestId('app-header')} />
      <div className={mainContainerStyle} {...getTestId('main-container')}>
        <div>
          <EntityHeader {...getTestId('entity-header')} />
        </div>
        <IndicatorsTabs />
      </div>
      <div className={contentContainer}>{children}</div>
    </>
  );
}
